import script from "./fan-top-three.vue?vue&type=script&setup=true&lang=js"
export * from "./fan-top-three.vue?vue&type=script&setup=true&lang=js"

import "./fan-top-three.vue?vue&type=style&index=0&id=749eaec0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749eaec0"]])

export default __exports__